const messages = {
  error: "Произошла ошибка. Попробуйте позже.",
  noData: "Данные не получены."
}

export default messages